// Small utility helpers used across pages that need light, deterministic
// randomness (e.g. picking one of the 4 AI category-cover variants for a
// given story) without pulling in a full hashing dep.

/**
 * FNV-1a 32-bit — fast, stable, unbiased enough for "pick a variant" logic.
 * Returns a signed 32-bit int; callers should use Math.abs() before %-modding.
 */
export function hashStr(s) {
  let h = 0x811c9dc5;
  for (let i = 0; i < (s || "").length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h | 0;
}

/**
 * Pick one item deterministically from `arr` based on a seed. Returns
 * `fallback` when the array is empty/null. Same seed => same pick, so
 * cards don't flicker between re-renders.
 */
export function pickVariant(arr, seed, fallback = null) {
  if (!arr?.length) return fallback;
  const idx = Math.abs(hashStr(String(seed || ""))) % arr.length;
  return arr[idx];
}
